export const BRAND = {
  name: "Paigez.ai",
  tagline: "Turn a new leaf.",
  logo: "https://customer-assets.emergentagent.com/job_magazine-native-app/artifacts/izpgt1ad_pAIgez.AI%20-%20logo%20design%2001.webp",
  colors: {
    bg: "#0A0A0A",
    magenta: "#E6007E",
    blue: "#00A6E6",
    lime: "#8BC53F",
    orange: "#F7941D",
    purple: "#6E2C9A",
  },
  hero: "https://images.unsplash.com/photo-1767475190453-28ff9b0545ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxwZXJzb24lMjByZWFkaW5nJTIwdGFibGV0JTIwbW9kZXJuJTIwZGFya3xlbnwwfHx8fDE3ODM4MzMxNjl8MA&ixlib=rb-4.1.0&q=85",
  covers: [
    "https://images.unsplash.com/photo-1596382940920-9f73b2d15901?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwbWFnYXppbmUlMjBjb3ZlciUyMGhpZ2glMjBlbmR8ZW58MHx8fHwxNzgzODMzMTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1781687282766-d6df9ef4c7fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwbWFnYXppbmUlMjBjb3ZlciUyMGhpZ2glMjBlbmR8ZW58MHx8fHwxNzgzODMzMTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1563721465742-cc3ead9deb36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxmYXNoaW9uJTIwbWFnYXppbmUlMjBjb3ZlciUyMGhpZ2glMjBlbmR8ZW58MHx8fHwxNzgzODMzMTY5fDA&ixlib=rb-4.1.0&q=85",
  ],
  reader: "https://images.unsplash.com/photo-1772839921960-6a81eb5a135c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxwZXJzb24lMjByZWFkaW5nJTIwdGFibGV0JTIwbW9kZXJuJTIwZGFya3xlbnwwfHx8fDE3ODM4MzMxNjl8MA&ixlib=rb-4.1.0&q=85",
  heroVideo: "/hero/ipad-demo.mp4",
};

export const NAV_LINKS = [
  { href: "#features", label: "Features" },
  { href: "#how-it-works", label: "How it Works" },
  { href: "#showcase", label: "Showcase" },
  { href: "#testimonials", label: "Voices" },
  { href: "#contact", label: "Contact" },
];
